export function isRateLimited(error) {
    return Number(error?.response?.status) === 429;
}
